import { digObject, formatDate } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useCampaign'

import type { CampaignModel } from '@models/types'

interface CamapignListItemProps {
  campaign: CampaignModel,
}

const CampaignListItem = (props: CamapignListItemProps) => {
  const { campaign } = props
  const { title } = campaign

  const updatedAt = digObject(campaign, 'dates.updated.date_time', '')
  const formattedDate = formatDate(updatedAt, 'dd/MM/yyyy HH:mm', 'ccc d LLL yyyy')

  const { campaignOverviewUrl } = generateUrls({ id: campaign.id })

  const showCampaign = () => {
    window.location.hash = campaignOverviewUrl
  }

  return (
    <DashboardModuleListItem
      onClick={showCampaign}
      secondaryText={`Updated ${formattedDate}`}
      // @ts-expect-error TS2322
      showAngleIcon
      title={title}
    />
  )
}

export default CampaignListItem
